import axios from 'axios'
import Service from '../Service'

class ExcelReportService extends Service {
  async download(param: any) {
    const res = await axios.post(this._buildUrl('/download'), param, {
      responseType: 'blob',
    })
    return res.data
  }

  async _download(param: any) {
    const res = await axios.post(this._buildUrl('/download/reportType'), param, {
      responseType: 'blob',
    })
    return res.data
  }
}

const domainService = new ExcelReportService('/reports/v1')

export default domainService
